import { render, staticRenderFns } from "./CarForm.vue?vue&type=template&id=b9f63fe2&scoped=true&"
import script from "./CarForm.vue?vue&type=script&lang=js&"
export * from "./CarForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f63fe2",
  null
  
)

export default component.exports